import { useEffect } from 'react';
import useDeleteRun from '@/hooks/api/runs/useDeleteRun.ts';
import ConfirmationModal from '@/components/ConfirmationModal.tsx';
import { Run } from '@/types/runs.ts';

type DeleteRunDialogProps = {
  run: Run;
  onClose: () => void;
};

const DeleteRunModal = ({ run, onClose }: DeleteRunDialogProps) => {
  const { mutate: deleteRun, isPending, isSuccess } = useDeleteRun(run.id);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <ConfirmationModal
      opened={true}
      onClose={onClose}
      title={'Delete Run'}
      onConfirm={() => deleteRun({})}
      confirmLoading={isPending}
      closeOnConfirm={false}
      message={`Are you sure you want to delete "${run.name}"?`}
      confirmText={'Delete'}
      confirmType={'delete'}
    />
  );
};

export default DeleteRunModal;
